<template>
  <div id="layersettings">
    <Button
      type="button"
      icon="pi pi-ellipsis-v"
      @click="toggle"
      aria-haspopup="true"
      aria-controls="transactions-settings"
      class="shadow-md"
    />
    <Menu
      ref="transactionsSettingsMenu"
      id="transactions-settings"
      :model="settingsMenuItems"
      :popup="true"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { TRANSACTION_LABEL_FIELDS } from '@/constants'
import { useMapStore } from '@/stores/map'

const { t } = useI18n()

const mapStore = useMapStore()
const { label: activeLabel, heatmapEnabled, heatmapField } = storeToRefs(mapStore)

const labelsList = TRANSACTION_LABEL_FIELDS
const transactionsSettingsMenu = ref(null)

const settingsMenuItems = computed(() => {
  return [
    {
      label: t('messages.transactions.settings.show_on_marker'),
      items: labelsList.map(label => ({
        label: t(`messages.transactions.fields.${label}`),
        value: label,
        command: () => {
          onChange(label)
        },
        class: activeLabel.value === label ? 'bg-blue-200 rounded-md' : '',
      })),
    },
    { separator: true },
    {
      label: t('messages.transactions.settings.heatmap'),
      items: [
        {
          label: heatmapEnabled.value
            ? t('messages.transactions.settings.heatmap_disable')
            : t('messages.transactions.settings.heatmap_enable'),
          icon: heatmapEnabled.value ? 'pi pi-eye-slash' : 'pi pi-eye',
          command: () => {
            heatmapEnabled.value = !heatmapEnabled.value
          },
        },
        ...TRANSACTION_LABEL_FIELDS.map(field => ({
          label: t(`messages.transactions.fields.${field}`),
          command: () => {
            heatmapField.value = field
          },
          class: heatmapField.value === field ? 'bg-green-200 rounded-md' : '',
          disabled: !heatmapEnabled.value,
        })),
      ],
    },
  ]
})

const onChange = id => {
  activeLabel.value = id
}

const toggle = () => {
  transactionsSettingsMenu.value.toggle(event)
}
</script>

<style scoped></style>
